module.exports = __webpack_public_path__ + "img/uid_background.b36b4d6.png";